import { TResponseType } from '@@types/base';
import instance from '@apis/instance';

const BASE_CORE_CONFIG_URL = '/core';

const BUSINESS_STATUS_URL = `${BASE_CORE_CONFIG_URL}/open/th`;
const checkBusinessStatus = () =>
  instance.get<TResponseType<{ open: boolean }>>(BUSINESS_STATUS_URL);

export default {
  checkBusinessStatus,
};
